import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';

const modalCustomClass = {
  popup: 'swal-modern-popup',
  icon: 'swal-modern-icon',
  title: 'swal-modern-title',
  htmlContainer: 'swal-modern-html',
  actions: 'swal-modern-actions',
  confirmButton: 'swal-modern-btn swal-modern-btn-confirm',
  denyButton: 'swal-modern-btn swal-modern-btn-cancel',
  cancelButton: 'swal-modern-btn swal-modern-btn-cancel',
};

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }

  toast(title: string, icon: "error" | "warning" | "success" | "info" | "question") {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      customClass: {
        popup: 'swal-modern-toast'
      },
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: icon,
      title: title
    })
  }

  confirm(title?: string, text?: string, icon?: "error" | "warning" | "success" | "info" | "question"): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Continuar',
      reverseButtons: true,
      buttonsStyling: false,
      customClass: modalCustomClass,
    })
  }

  confirmtHtml(title?: string, text?: string, confirmText?: string, denyText?: string, icon?: "error" | "warning" | "success" | "info" | "question"): Promise<SweetAlertResult<any>> {

    return Swal.fire({
      title: title,
      html: text,
      icon: icon,
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: confirmText != null ? confirmText : 'Continuar',
      denyButtonText: denyText != null ? denyText : 'Cancelar',
      reverseButtons: true,
      buttonsStyling: false,
      customClass: modalCustomClass,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    })
  }

  confirmAlert(title?: string, text?: string, icon?: "error" | "warning" | "success" | "info" | "question"): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCancelButton: false,
      confirmButtonText: 'Continuar',
      buttonsStyling: false,
      customClass: modalCustomClass,
    })
  }

  confirmAlertHtml(title?: string, text?: string, icon?: "error" | "warning" | "success" | "info" | "question"): Promise<SweetAlertResult<any>> {
    return Swal.fire({
      title: title,
      html: text,
      icon: icon,
      showCancelButton: false,
      confirmButtonText: 'Continuar',
      buttonsStyling: false,
      customClass: modalCustomClass,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    })
  }

}
